
import PosjecenostClanka from "./PosjecenostClanka";
import UkupnaPosjecenostClanka from "./UkupnaPosjecenostClanka";
import TopClanci from "./TopDesetClanaka";
import { Row } from "antd";
import "./StatistikaClanakaPage.css";
import Background from "../../components/Background4";

const StatistikaClanka = () => {
  return (
    <div>
      <Background />

      <div className="statclankapage">
        <div className="statistika-clanka-frame">
          <div className="statclankapage-div">
            <Row>
              <PosjecenostClanka />
            </Row>
            <Row style={{ width: "100%" }}>
              <UkupnaPosjecenostClanka />
            </Row>
            <Row style={{ width: "100%" }}>
              <TopClanci />
            </Row>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatistikaClanka;
